import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useAddOtherPageBannerMutation } from "../../../Services/HomeAPI";
import { useNavigate } from "react-router-dom";

function AddCategory() {
    const navigate = useNavigate();
    const [title, setTitle] = useState("");
    const [image, setImage] = useState(null);
    const [pageName, setPageName] = useState("")
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);

    const [addBanner, { isLoading }] = useAddOtherPageBannerMutation();

    const validateForm = () => {
        let newErrors = {};
        if (!title.trim()) newErrors.title = "Title is required";
        if (!pageName.trim()) newErrors.pageName = "Page Name is required";
        if (!image) newErrors.image = "Image is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const formData = new FormData();

        formData.append("page_name", pageName);
        formData.append("title", title);
        formData.append("banner_image", image);


        try {
            await addBanner(formData).unwrap();
            alert("Banner added successfully!");
            setTitle("");
            setImage(null);

            setErrors({});
            setApiError(null);
            navigate("/other-banner-list");
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };

    return (
        <div>
            <h3>Add Banner</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/other-banner-list"><span>Banner</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">Add</span>
                </p>
            </div>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Page Name</label>
                                <select value={pageName} className="form-control" onFocus={() => setErrors((prevErrors) => ({ ...prevErrors, pageName: "" }))} onChange={(e) => setPageName(e.target.value)}>
                                    <option value="">Select Page Name</option>
                                    <option value="About Us">About Us</option>
                                    <option value="Contact Us">Contact Us</option>
                                    <option value="Shop">Shop</option>
                                    <option value="Cart">Cart</option>
                                    <option value="Register">Register</option>
                                    <option value="Login">Login</option>
                                </select>
                                {errors.pageName && <p className="text-danger">{errors.pageName}</p>}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Title</label>
                                <input type="text" className="form-control" onFocus={() => setErrors((prevErrors) => ({ ...prevErrors, title: "" }))} placeholder="Enter Title" value={title} onChange={(e) => setTitle(e.target.value)} />
                                {errors.title && <p className="text-danger">{errors.title}</p>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Image</label>
                                <input type="file" className="form-control" onFocus={() => setErrors((prevErrors) => ({ ...prevErrors, image: "" }))} onChange={(e) => setImage(e.target.files[0])} />
                                {errors.image && <p className="text-danger">{errors.image}</p>}
                            </div>
                        </div>
                    </div>
                    {apiError && <p className="text-danger text-center">{apiError}</p>}
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;